export default "__VITE_ASSET__CfbZcrw2__"